import { useCallback, useEffect, useState } from 'react';
import { shouldDisableBrowserClose } from 'App/ProgressAlert/utils';
import { FeatureFlag } from 'Environment/FeatureFlag';
import { useFeatureCanary } from 'utils/useFeatureCanary';
import { ResourceLaunchProgressMap } from 'Workspace/ResourceProvider/Context';

export const usePreventBrowserClose = (launchProgress: ResourceLaunchProgressMap) => {
	const [showWait, setShowWait] = useState(false);

	const avoidBrowserClose = useCallback((event: Event) => {
		setShowWait(true);
		event.preventDefault();
		event.returnValue = true;
		return false;
	}, []);
	const isBeforeUnloadSupported = useFeatureCanary(
		FeatureFlag.EnableBeforeunloadForProgressAlert
	);

	useEffect(() => {
		const disableBrowserClose =
			shouldDisableBrowserClose(launchProgress) && isBeforeUnloadSupported;

		if (!disableBrowserClose) {
			setShowWait(false);
		}

		if (disableBrowserClose) {
			window.addEventListener('beforeunload', avoidBrowserClose);
		}

		return () => {
			if (disableBrowserClose) {
				window.removeEventListener('beforeunload', avoidBrowserClose);
			}
		};
	}, [launchProgress, avoidBrowserClose, isBeforeUnloadSupported]);

	return { showWait, setShowWait };
};
